const months = {
  January: "01",
  February: "02",
  March: "03",
  April: "04",
  May: "05",
  June: "06",
  July: "07",
  August: "08",
  September: "09",
  October: "10",
  November: "11",
  December: "12",
} as const;

type MonthKeys = keyof typeof months;

export function getMonthNumber(monthName: MonthKeys): string | undefined {
  return months[monthName];
}

export function getLastDateOfMonth(
  month: number,
  year: number = new Date().getFullYear(),
): number {
  if (month < 1 || month > 12) {
    throw new Error("Month must be between 1 and 12");
  }

  // Create a date object for the next month and set the day to 0 to get the last day of the current month
  const lastDay = new Date(year, month, 0).getDate();

  return lastDay;
}

export function getMonthDifference(startDate: string, endDate: string): number {
  // Parse the input date strings
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (isNaN(start.getTime()) || isNaN(end.getTime())) {
    throw new Error("Invalid date format");
  }

  // Calculate the year and month difference
  const yearsDiff: number = end.getFullYear() - start.getFullYear();
  const monthsDiff: number = end.getMonth() - start.getMonth();

  // Total difference in months
  return Math.abs(yearsDiff * 12 + monthsDiff);
}
